import React from 'react'
import { Button, Result } from 'antd'
import { useRouter } from 'next/router'
import { useSelector } from 'react-redux'
import { ReloadOutlined } from '@ant-design/icons'
import { useLogErrorMutation } from '@/features/errorHandling/apis/errorLoggingApi'

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError() {
    // Update state to show fallback UI
    return { hasError: true }
  }

  async componentDidCatch(error, errorInfo) {
    const { logError, profile } = this.props

    const payload = {
      app: 'USER',
      type: 'FRONTEND',
      message: error.message,
      url: typeof window !== 'undefined' ? window.location.href : '',
      stack: error.stack,
      componentStack: errorInfo.componentStack,
      timestamp: new Date().toISOString(),
    }

    if (profile) {
      payload.user = {
        id: profile.id,
        name: `${profile.name} ${profile.lname || ''}`.trim(),
        email: profile.email,
      }
    }

    try {
      await logError(payload)
    } catch (e) {
      console.warn('Failed to send error to server:', e)
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <Result
          status='500'
          title='Errore imprevisto'
          subTitle='Ci scusiamo, qualcosa è andato storto. Prova ad aggiornare la pagina o torna alla home page.'
          extra={
            <div className='flex items-center justify-center gap-8'>
              <Button
                icon={<ReloadOutlined />}
                className='btn-green-outlined text-lg font-bold rounded-lg h-auto py-12 px-36'
                onClick={() => window.location.reload()}
              >
                Ricaricare
              </Button>
              <Button
                className='btn-green text-lg font-bold rounded-lg h-auto py-12 px-36'
                onClick={() => this.props.router.push('/')}
              >
                Ritorno a casa
              </Button>
            </div>
          }
        />
      )
    }

    return this.props.children
  }
}

// Wrap ErrorBoundary in a functional component to access `useRouter`
const ErrorBoundaryWithRouter = (props) => {
  const router = useRouter()
  const [logError] = useLogErrorMutation()
  const { profile } = useSelector((state) => state.auth)

  return (
    <ErrorBoundary
      {...props}
      router={router}
      logError={logError}
      profile={profile}
    />
  )
}

export default ErrorBoundaryWithRouter
